import React, { useEffect, useState } from "react";

interface IUseSectionProps {
    title: string;
    id: string;
}

interface IUseSectionNavigationProps {
    sections: IUseSectionProps[];
}

const useSectionsNavigation = ({ sections }: IUseSectionNavigationProps) => {
    const [activeTab, setActiveTab] = useState<string>('');
    const [scrollTopData, setScrollTopData] = useState('');

    const sectionsIds = sections.map((section) => section.id);

    useEffect(() => {
        const urlMain = window.location.hash.replace('#', '');
        setActiveTab(urlMain);
        scrollToCategory(urlMain);
    }, []);

    const updateMainUrl = (anchor: string): void => {
        window.location.hash = `#${anchor}`;
    }

    const scrollToCategory = (productCategorySlug: string): void => {
        const container = document.documentElement;
        const elementTop = document.getElementById(`section-${productCategorySlug}`)?.getBoundingClientRect().top ?? 0;
        const headerHeight = document.getElementById('customizationList-stickyHeader')?.getBoundingClientRect().height ?? 0;

        const from = container.scrollTop;
        const delta = elementTop - headerHeight;
        const startTime = performance.now();

        const absDelta = Math.abs(delta);

        const duration = absDelta < 100 ? 250 : absDelta < 500 ? 500 : 1000;

        const easeInOutQuad = (x: number): number => x < 0.5 ? 2 * x * x : -1 - x * (2 * x - 4);

        const scrollProcess = (): void => {
            const percentDone = (performance.now() - startTime) / duration;
            container.scrollTop = from + delta * easeInOutQuad(percentDone);

            if (percentDone < 1) {
                window.requestAnimationFrame(scrollProcess);
            }
        };

        window.requestAnimationFrame(scrollProcess);
    };

    React.useEffect(() => {
        const handleScroll = () => {
            let maxElement;
            let maxElementHeight = 0;
            let maxElementCategory;

            for (const category of sectionsIds) {
                const element = document.getElementById(`section-${category}`);
                if (element !== null) {
                    const elementRect = element.getBoundingClientRect();

                    if (elementRect.top < window.innerHeight && elementRect.bottom > 0) {
                        const top = elementRect.top < 0 ? 0 : elementRect.top;
                        const bottom = elementRect.bottom > window.innerHeight ? window.innerHeight : elementRect.bottom;
                        const elementHeight = bottom - top;

                        if (elementHeight > maxElementHeight) {
                            maxElementHeight = elementHeight;
                            maxElement = element;
                            maxElementCategory = category;
                        }
                    }
                }
            }

            if (maxElementCategory !== undefined) {
                setActiveTab(maxElementCategory);
            }
        }

        document.addEventListener('scroll', handleScroll);

        return () => {
            document.removeEventListener('scroll', handleScroll);
        };
    }, [sectionsIds]);

    React.useEffect(() => {
        const scrollHandler = () => {
            const nav = document.getElementById('customizationList-wrapper');
            if (nav !== null) {
                const navTop = nav.offsetTop ?? '';
                if (window.scrollY >= navTop) {
                    setScrollTopData('shadow');
                } else {
                    setScrollTopData('');
                }
            }
        }
        window.addEventListener('scroll', scrollHandler);
    }, [scrollTopData]);

    return {
        activeTab,
        setActiveTab,
        scrollTopData,
        setScrollTopData,
        updateMainUrl,
        scrollToCategory,
    };
}

export default useSectionsNavigation;
